import { createReducer, on } from '@ngrx/store';
import * as TagActions from './tag.actions';

export interface TagState {
  tags: any[];
  loading: boolean;
  error: string | null;

  // Investment related state
  searchId: string | null;
  investmentLabel: string | null;
  investmentColor: string | null;
  investmentLoading: boolean;
  investmentError: string | null;
}

export const initialState: TagState = {
  tags: [],
  loading: false,
  error: null,

  // Investment related initial state
  searchId: null,
  investmentLabel: null,
  investmentColor: null,
  investmentLoading: false,
  investmentError: null
};

export const tagReducer = createReducer(
  initialState,

  // Load tags
  on(TagActions.loadTags, state => ({ ...state, loading: true, error: null })),
  on(TagActions.loadTagsSuccess, (state, { tags }) => ({
    ...state,
    tags,
    loading: false
  })),
  on(TagActions.loadTagsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),

  // Add tag
  on(TagActions.addTag, state => ({ ...state, loading: true, error: null })),
  on(TagActions.addTagSuccess, (state, { tag }) => ({
    ...state,
    tags: [...state.tags, tag],
    loading: false
  })),
  on(TagActions.addTagFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),

  // Remove tag
  on(TagActions.removeTag, state => ({ ...state, loading: true, error: null })),
  on(TagActions.removeTagSuccess, (state, { tag }) => ({
    ...state,
    tags: state.tags.filter(t => t !== tag),
    loading: false
  })),
  on(TagActions.removeTagFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),

  // Attach tag to report
  on(TagActions.attachTag, state => ({ ...state, loading: true, error: null })),
  on(TagActions.attachTagSuccess, (state) => ({
    ...state,
    loading: false
  })),
  on(TagActions.attachTagFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),

  // Detach tag from report
  on(TagActions.detachTag, state => ({ ...state, loading: true, error: null })),
  on(TagActions.detachTagSuccess, (state) => ({
    ...state,
    loading: false
  })),
  on(TagActions.detachTagFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),

  // Investment-related reducers
  on(TagActions.loadInvestment, state => ({
    ...state,
    investmentLoading: true,
    investmentError: null
  })),
  on(TagActions.loadInvestmentSuccess, (state, { searchId, investmentLabel, investmentColor }) => ({
    ...state,
    searchId,
    investmentLabel,
    investmentColor,
    investmentLoading: false,
    investmentError: null
  })),
  on(TagActions.loadInvestmentFailure, (state, { error }) => ({
    ...state,
    investmentLoading: false,
    investmentError: error
  })),
  on(TagActions.resetInvestment, (state) => ({
    ...state,
    searchId: null,
    investmentLabel: null,
    investmentColor: null,
    investmentLoading: false,
    investmentError: null
  }))
);
